import { RAISE_API_V1_URL } from "constants/endpoints";
import { post } from "services/api";
import { prepareRiskRequest } from "services/sardine";

/**
 * Returns a Promise that resolves to an object containing the user token.
 * @typedef {Object} TwoFactorAuthenticationRequiredResponse
 * @property {true} data.verification_required
 * @property {string} data.patch_token
 *
 * @typedef {Object} AccessTokenGrantedResponse
 * @property {false} data.verification_required
 * @property {string} data.access_token
 * @property {Date} data.token_expiration
 * @returns {Promise<TwoFactorAuthenticationRequiredResponse|AccessTokenGrantedResponse>} A Promise that resolves to an object with sign in properties.
 */
export const signIn = async ({
  email,
  password,
  fingerprint,
  shouldRemember,
  captchaToken
}) => {
  const risk = await prepareRiskRequest("login");
  const URL = `${RAISE_API_V1_URL}/tokens`;
  const body = {
    user: {
      email,
      password
    },
    recaptcha_token: captchaToken,
    // TODO fix this property name to 'remember_me', after backend fixes also
    remeber_me: shouldRemember
  };
  const headers = {
    "device-fingerprint": fingerprint,
    "X-Risk-Collection": risk.collection
  };
  if (risk.sessionId) headers["X-Session"] = risk.sessionId;
  const response = await post(URL, body, { headers });
  return response.data.data || response.data;
};
